




































































import { Vue, Component } from 'vue-property-decorator';
import { Toast, Field, SwipeItem, Swipe, Icon, ImagePreview } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import Uploader from '@/components/next/NewUploader.vue';
import { register, getUserInfo } from '../api';
import { unionIdIsBind } from '@/api/api';
import qs from 'qs';

Vue.use(Toast).use(Field).use(Swipe).use(SwipeItem).use(Icon).use(ImagePreview);
@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  title = '';
  stuName = '';
  teacherName = '';
  schoolName = '';
  age :number = 3;
  intro = '';
  phone = '';
  showSave :number = 2;
  detail: any = {};
  rfupload :boolean = false;
  textupload :boolean = false;
  uploadtext = '';

  async created() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
    }
    this.checkIsBind();
    const user: any = await getUserInfo(
      window.localStorage.getItem('unionid')
        ? window.localStorage.getItem('unionid')
        : '',
    );
    if(user.code === 200){
      this.showSave = 3;
      this.detail = user.data;
      if(user.data.enable === '-1'){
        this.uploadtext = '审核未通过';
        this.rfupload = true;
        this.textupload = true;
      } else if(user.data.enable === '0'){
        this.uploadtext = '审核中...';
        this.rfupload = false;
        this.textupload = true;
      } else {
        this.rfupload = false;
        this.textupload = false;
      }
    }else if(user.code === 202){
      this.showSave = 2;
    }else{
      this.showSave = 1;
    }
  }
  checkForm() {
    if (!this.title) {
      Toast('请填写作品名称');
      return false;
    } else if (!this.stuName) {
      Toast('请填写作者姓名');
      return false;
    } else if (!this.age) {
      Toast('请填写年龄');
      return false;
    } else if (isNaN(this.age)){
      Toast('年龄必须为3-14岁之间！');
      return false;
    } else if (this.age < 3 || this.age > 14){
      Toast('年龄必须为3-14岁之间！');
      return false;
    } else {
      return true;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onSubmit() {
    if (!this.checkForm()) {
      return;
    }
    const retImages: any = await (
      this.$refs.uploader as Uploader
    ).uploadToOss();
    const retRegister: any = await register({
      unionid: window.localStorage.getItem('unionid'),
      title: this.title,
      name: this.stuName,
      year: this.age,
      cover: retImages.join('|'),
      udid: window.udid,
      appkey: window.appkey,
    });
    if (retRegister.code === 200) {
      Toast(retRegister.msg);
      this.reset();
    } else {
      Toast(retRegister.msg);
    }
  }
  reset() {
    setTimeout(() => {
      this.$router.go(0);
    }, 1500);
  }

  async checkIsBind() {
      const data = {
        type: 2,
        unionId: window.localStorage.getItem('unionid'),
      };
      if (window.udid) {
        this.AppLogin();
      } else if (isWeiXin()) {
        const res: any = await unionIdIsBind(data);
        if (!res.data) {
          this.$router.push(
            `/BindPhone?url=${encodeURIComponent(location.href)}`,
          );
          return false;
        } else {
          return true;
        }
      }
    }
    onSliderClick(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
  async showSaveButton() {
    this.showSave = 1;
  }

  onNavTo(id: any, enable: any) {
    if(enable === '1'){
      this.$router.push(`detail?id=${id}`);
    }
  }

}
